import $ from 'jquery';
import { Moves } from '../language/moves';
import { Pokemon } from '../language/pokemon';
import { Pokedex } from '../js/pokedex';
import { Formes } from '../language/formes';

let nameLinePat = /^(?!.*(- |:|Nature))(.+?)\s?(\([^\)]*\))?\s?(?:\([MF]\))? ?(@[^@]*)?$/;
let abilityLinePat = /^Ability: (.*)$/;
let teraTypeLinePat = /^Tera Type: (.*)$/;
let levelLinePat = /^Level: (.*)$/;
let natureLinePat = /^(.*) Nature$/;
let moveLinePat = /^-\s?(.*)$/;
let evRegex = /^EVs: (.*)/;
let ivRegex = /^IVs: (.*)/;

let warning = "This Battle Team List matches the Battle Team used in the listed event exactly.\
All Pokémon are listed exactly as they appear in the ingame Battle Team, including stats and attack order.\
If any of your Pokémon have the move Hidden Power, write it as \"HP (X)\" with the (X) stating the elemental type. \
If the information on this sheet does not match the Battle Team exactly, penalties may be incurred.";


$(document).ready(function () {
	$('#OK').click(generate);
	// $('#print').click(printFunction);
});

// let printFunction = function () {
// 	generate();
// 	setTimeout(function () { //allows time for images (gender icons) to load
// 		window.print();
// 	}, 250);
// }

let generate = () => {
	console.log('GENERATE');
	let publicText = '';
	let teamlist = $('#roster').val();
	let monList = [];
	let lines = teamlist.split('\n');
	for (let i = 0; i < lines.length; ++i) {
		lines[i] = lines[i].trim();
		if (nameLinePat.test(lines[i])) {
			monList.push(new mon());
			if (lines[i].includes("(M)")) monList[monList.length - 1].gender = "M";
			else if (lines[i].includes("(F)")) monList[monList.length - 1].gender = "F";
			monList[monList.length - 1].level = 100;
			let species_line = '';
			species_line = nameLinePat.exec(lines[i]);
			if (species_line[2 + 1] === undefined || species_line[2 + 1].length === 3) { //no nickname
				monList[monList.length - 1].species = species_line[1 + 1].trim();
			}
			else { //has a nickname
				monList[monList.length - 1].species = species_line[2 + 1].slice(1, species_line[2 + 1].length - 1);
			}
			if (species_line[3 + 1] !== undefined && lines[i].includes("@")) { // check for item
				monList[monList.length - 1].item = species_line[3 + 1].substring(2);
			}
			monList[monList.length - 1] = SPECIAL_FORME_FILTERING(monList[monList.length - 1]);
			if (Pokedex[monList[monList.length - 1].species.toLowerCase().replace(/[ '-]/g, '')]) {
				if (Pokedex[monList[monList.length - 1].species.toLowerCase().replace(/[ '-]/g, '')]["gender"] !== undefined) {
					monList[monList.length - 1].gender = Pokedex[monList[monList.length - 1].species.toLowerCase().replace(/[ '-]/g, '')]["gender"];
				}
			}
		}
		else if (monList.length !== 0) {
			if (abilityLinePat.test(lines[i]) && monList[monList.length - 1].ability === "") {
				monList[monList.length - 1].ability = abilityLinePat.exec(lines[i])[1];
				monList[monList.length - 1] = SPECIAL_FORME_FILTERING(monList[monList.length - 1]);
			} else if (teraTypeLinePat.test(lines[i]) && monList[monList.length - 1].teratype === "") {
				monList[monList.length - 1].teratype = teraTypeLinePat.exec(lines[i])[1];
			} else if (natureLinePat.test(lines[i])) {
				monList[monList.length - 1].nature = natureLinePat.exec(lines[i])[1];
			} else if (moveLinePat.test(lines[i])) {
				if (monList[monList.length - 1].move1 === "") monList[monList.length - 1].move1 = moveLinePat.exec(lines[i])[1];
				else if (monList[monList.length - 1].move2 === "") monList[monList.length - 1].move2 = moveLinePat.exec(lines[i])[1];
				else if (monList[monList.length - 1].move3 === "") monList[monList.length - 1].move3 = moveLinePat.exec(lines[i])[1];
				else if (monList[monList.length - 1].move4 === "") monList[monList.length - 1].move4 = moveLinePat.exec(lines[i])[1];
			} else if (levelLinePat.test(lines[i])) {
				monList[monList.length - 1].level = parseInt(levelLinePat.exec(lines[i])[1]);
			} else if (evRegex.test(lines[i])) {
				let evstring = lines[i].trim().substring(4, lines[i].length).split('/');
				for (let j = 0; j < evstring.length; ++j) {
					evstring[j] = evstring[j].trim();
					if (evstring[j].includes("HP")) monList[monList.length - 1].hpev = parseInt(evstring[j].substring(0, evstring[j].indexOf("HP") - 1));
					if (evstring[j].includes("Atk")) monList[monList.length - 1].atkev = parseInt(evstring[j].substring(0, evstring[j].indexOf("Atk") - 1));
					if (evstring[j].includes("Def")) monList[monList.length - 1].defev = parseInt(evstring[j].substring(0, evstring[j].indexOf("Def") - 1));
					if (evstring[j].includes("SpA")) monList[monList.length - 1].spatkev = parseInt(evstring[j].substring(0, evstring[j].indexOf("SpA") - 1));
					if (evstring[j].includes("SpD")) monList[monList.length - 1].spdefev = parseInt(evstring[j].substring(0, evstring[j].indexOf("SpD") - 1));
					if (evstring[j].includes("Spe")) monList[monList.length - 1].speev = parseInt(evstring[j].substring(0, evstring[j].indexOf("Spe") - 1));
				}
			}
			else if (ivRegex.test(lines[i])) {
				let ivstring = lines[i].trim().substring(4, lines[i].length).split('/');
				for (let j = 0; j < ivstring.length; ++j) {
					ivstring[j] = ivstring[j].trim();
					if (ivstring[j].includes("HP")) monList[monList.length - 1].hpiv = parseInt(ivstring[j].substring(0, ivstring[j].indexOf("HP") - 1));
					if (ivstring[j].includes("Atk")) monList[monList.length - 1].atkiv = parseInt(ivstring[j].substring(0, ivstring[j].indexOf("Atk") - 1));
					if (ivstring[j].includes("Def")) monList[monList.length - 1].defiv = parseInt(ivstring[j].substring(0, ivstring[j].indexOf("Def") - 1));
					if (ivstring[j].includes("SpA")) monList[monList.length - 1].spatkiv = parseInt(ivstring[j].substring(0, ivstring[j].indexOf("SpA") - 1));
					if (ivstring[j].includes("SpD")) monList[monList.length - 1].spdefiv = parseInt(ivstring[j].substring(0, ivstring[j].indexOf("SpD") - 1));
					if (ivstring[j].includes("Spe")) monList[monList.length - 1].speiv = parseInt(ivstring[j].substring(0, ivstring[j].indexOf("Spe") - 1));
				}
			}
		}
	}
	for (let u = 0; u < lines.length; u++) {
		if (evRegex.test(lines[u]) || ivRegex.test(lines[u])) {
		} else {
			publicText += lines[u] + '\n';
		}
	}
	$('#rosterpublic').text(publicText)
	console.log(monList)

	for (let i = 0; i < monList.length; ++i) {
		monList[i].calcStats();
		monList[i].species = addText(monList[i].species);
	}

	for (let i = 0; i < 6; i++) { // Reset tables
		console.log('reset')
		$('.ptable').show();
		$('.ptable').eq(i).find("#pokemon").text('');
		$('.ptable').eq(i).find("#ability").text('');
		$('.ptable').eq(i).find("#teratype").text('');
		$('.ptable').eq(i).find("#heldItem").text('');
		$('.ptable').eq(i).find("#move1").text('');
		$('.ptable').eq(i).find("#move2").text('');
		$('.ptable').eq(i).find("#move3").text('');
		$('.ptable').eq(i).find("#move4").text('');
		$('.ptable').eq(i).find("#level").text('');
		$('.ptable').eq(i).find("#hp").text('');
		$('.ptable').eq(i).find("#atk").text('');
		$('.ptable').eq(i).find("#def").text('');
		$('.ptable').eq(i).find("#spatk").text('');
		$('.ptable').eq(i).find("#spdef").text('');
		$('.ptable').eq(i).find("#spe").text('');
		$('.ptable').eq(i).find("#gender").html("<img width = 70px src=\"images/gender_NA.png\"></img>");
	}

	for (let pokemon in monList) {
		let typeHtml = '';
		let moveHtml = '';
		$('.ptable').show();
		$('.ptable').eq(pokemon).find("#pokemon").text(monList[pokemon].species);
		// $('.ptable').eq(pokemon).find("#gigantamaxCheckbox").prop("checked", monList[pokemon].gigantamax);
		$('.ptable').eq(pokemon).find("#ability").text(monList[pokemon].ability);
		$('.ptable').eq(pokemon).find("#teratype").text(monList[pokemon].teratype);
		$('.ptable').eq(pokemon).find("#heldItem").text(monList[pokemon].item);
		$('.ptable').eq(pokemon).find("#move1").text(monList[pokemon].move1);
		$('.ptable').eq(pokemon).find("#move2").text(monList[pokemon].move2);
		$('.ptable').eq(pokemon).find("#move3").text(monList[pokemon].move3);
		$('.ptable').eq(pokemon).find("#move4").text(monList[pokemon].move4);
		$('.ptable').eq(pokemon).find("#level").text(monList[pokemon].level);
		$('.ptable').eq(pokemon).find("#hp").text(monList[pokemon].hp);
		$('.ptable').eq(pokemon).find("#atk").text(monList[pokemon].atk);
		$('.ptable').eq(pokemon).find("#def").text(monList[pokemon].def);
		$('.ptable').eq(pokemon).find("#spatk").text(monList[pokemon].spatk);
		$('.ptable').eq(pokemon).find("#spdef").text(monList[pokemon].spdef);
		$('.ptable').eq(pokemon).find("#spe").text(monList[pokemon].spe);

		$('.pkmnCard').eq(pokemon).find("#visualPokemonText").text(monList[pokemon].species);
		$('.pkmnCard').eq(pokemon).find("#visualAbilityText").text(monList[pokemon].ability);
		$('.pkmnCard').eq(pokemon).find("#teratype").text(monList[pokemon].teratype);
		$('.pkmnCard').eq(pokemon).find("#visualHeldItemText").text(monList[pokemon].item);
		$('.pkmnCard').eq(pokemon).find("#visualMove1").text(monList[pokemon].move1);
		$('.pkmnCard').eq(pokemon).find("#visualMove2").text(monList[pokemon].move2);
		$('.pkmnCard').eq(pokemon).find("#visualMove3").text(monList[pokemon].move3);
		$('.pkmnCard').eq(pokemon).find("#visualMove4").text(monList[pokemon].move4);
		$('.pkmnCard').eq(pokemon).find("#visualLevelText").text('Lv. ' + monList[pokemon].level);
		$('.pkmnCard').eq(pokemon).find("#visualGender").html(``);

		// <img style={{ maxWidth: 'min(2vw,25px)', maxHeight: 'min(2vw,25px)', width: 'auto', height: 'auto', marginLeft: '5%', borderRadius: 999 }} src="/images/types/fighting.png" />
		// <img style={{ maxWidth: 'min(2vw,25px)', maxHeight: 'min(2vw,25px)', width: 'auto', height: 'auto', marginLeft: '5%', borderRadius: 999 }} src="/images/types/dragon.png" />
		// <div style={{ width: '0.15vw', height: '2vw', backgroundColor: '#FFF', marginLeft: '5%' }}></div>
		// <img style={{ maxWidth: 'min(2vw,25px)', maxHeight: 'min(2vw,25px)', width: 'auto', height: 'auto', marginRight: '5%', marginLeft: '5%' }} src="/images/teratypes/dark.png" />
		// style={{ maxWidth: 'min(2vw,25px)', maxHeight: 'min(2vw,25px)', width: 'auto', height: 'auto', marginLeft: '5%', borderRadius: 999 }}
		console.log(monList[pokemon].species.toLowerCase().replace(/[ '-]/g, ''));
		if (Pokedex[monList[pokemon].species.toLowerCase().replace(/[ '-]/g, '')]) {
			for (let k = 0; k < Pokedex[monList[pokemon].species.toLowerCase().replace(/[ '-]/g, '')]['types'].length; k++) {
				typeHtml += `<img src="/images/types/${Pokedex[monList[pokemon].species.toLowerCase().replace(/[ '-]/g, '')]['types'][k].toLowerCase()}.png" />`
			}
			typeHtml += `<div id="visualDivider"></div>`;
			typeHtml += `<img src="/images/teratypes/${monList[pokemon].teratype.toLowerCase()}.png" />`
			$('.pkmnCard').eq(pokemon).find("#visualPkmnTypes").html(typeHtml);
		} else if (monList[pokemon].species.toLowerCase().replace(/[ '-]/g, '').includes('tatsugiri')) {
			for (let k = 0; k < Pokedex['tatsugiri']['types'].length; k++) {
				typeHtml += `<img src="/images/types/${Pokedex['tatsugiri']['types'][k].toLowerCase()}.png" />`
			}
			typeHtml += `<div id="visualDivider"></div>`;
			typeHtml += `<img src="/images/teratypes/${monList[pokemon].teratype.toLowerCase()}.png" />`
			$('.pkmnCard').eq(pokemon).find("#visualPkmnTypes").html(typeHtml);
		}
		if (Moves[monList[pokemon].move1]) {
			moveHtml = `<img src="/images/types/${Moves[monList[pokemon].move1]['TYPE'].toLowerCase()}.png" />`
			$('.pkmnCard').eq(pokemon).find("#visualMoveType1").html(moveHtml);
		}
		if (Moves[monList[pokemon].move2]) {
			moveHtml = `<img src="/images/types/${Moves[monList[pokemon].move2]['TYPE'].toLowerCase()}.png" />`
			$('.pkmnCard').eq(pokemon).find("#visualMoveType2").html(moveHtml);
		}
		if (Moves[monList[pokemon].move3]) {
			moveHtml = `<img src="/images/types/${Moves[monList[pokemon].move3]['TYPE'].toLowerCase()}.png" />`
			$('.pkmnCard').eq(pokemon).find("#visualMoveType3").html(moveHtml);
		}
		if (Moves[monList[pokemon].move4]) {
			moveHtml = `<img src="/images/types/${Moves[monList[pokemon].move4]['TYPE'].toLowerCase()}.png" />`
			$('.pkmnCard').eq(pokemon).find("#visualMoveType4").html(moveHtml);
		}
		console.log(monList[pokemon].species);

		if (monList[pokemon].species.slice(-2) == '-M') {
			$('.pkmnCard').eq(pokemon).find("#visualPkmnImg").html(`<img src="${Pokemon[monList[pokemon].species.slice(0, -2)][0]['SPRITE']}" />`);
		} else if (monList[pokemon].species.slice(-2) == '-F') {
			$('.pkmnCard').eq(pokemon).find("#visualPkmnImg").html(`<img src="${Pokemon[monList[pokemon].species.slice(0, -2)][0]['SPRITE'].slice(0, Pokemon[monList[pokemon].species.slice(0, -2)][0]['SPRITE'].indexOf('.png')) + '-1.png'}" />`);
		}
		else if (Pokemon[monList[pokemon].species]) {
			$('.pkmnCard').eq(pokemon).find("#visualPkmnImg").html(`<img src="${Pokemon[monList[pokemon].species][0]['SPRITE']}" />`);
		} else if (Formes[monList[pokemon].species]) {
			$('.pkmnCard').eq(pokemon).find("#visualPkmnImg").html(`<img src="${Formes[monList[pokemon].species]['SPRITE']}" />`);
		}

		if (monList[pokemon].gender === "M") {
			$('.ptable').eq(pokemon).find("#gender").html("<img width = 70px src=\"images/gender_M.png\"></img>");
			$('.pkmnCard').eq(pokemon).find("#visualGender").html(`<img src="/images/gender/male.png" />`);
		}
		else if (monList[pokemon].gender === "F") {
			$('.ptable').eq(pokemon).find("#gender").html("<img width = 70px src=\"images/gender_F.png\"></img>");
			$('.pkmnCard').eq(pokemon).find("#visualGender").html(`<img src="/images/gender/female.png" />`);
		}
		else {
			$('.ptable').eq(pokemon).find("#gender").html("<img width = 70px src=\"images/gender_NA.png\"></img>");
		}
	}
};

function calcStats() {
	if (Pokedex[this.species.toLowerCase().replace(/[ '-]/g, '')]) {
		this.hp = CALC_HP_ADV(this.species.toLowerCase().replace(/[ '-]/g, ''), this.hpev, this.hpiv, this.level);
		this.atk = CALC_STAT_ADV(this.species.toLowerCase().replace(/[ '-]/g, ''), this.atkev, this.atkiv, this.nature, this.level, "atk");
		this.def = CALC_STAT_ADV(this.species.toLowerCase().replace(/[ '-]/g, ''), this.defev, this.defiv, this.nature, this.level, "def");
		this.spatk = CALC_STAT_ADV(this.species.toLowerCase().replace(/[ '-]/g, ''), this.spatkev, this.spatkiv, this.nature, this.level, "spa");
		this.spdef = CALC_STAT_ADV(this.species.toLowerCase().replace(/[ '-]/g, ''), this.spdefev, this.spdefiv, this.nature, this.level, "spd");
		this.spe = CALC_STAT_ADV(this.species.toLowerCase().replace(/[ '-]/g, ''), this.speev, this.speiv, this.nature, this.level, "spe");
	} else if (this.species.toLowerCase().replace(/[ '-]/g, '').includes('tatsugiri')) {
		this.hp = CALC_HP_ADV('tatsugiri', this.hpev, this.hpiv, this.level);
		this.atk = CALC_STAT_ADV('tatsugiri', this.atkev, this.atkiv, this.nature, this.level, "atk");
		this.def = CALC_STAT_ADV('tatsugiri', this.defev, this.defiv, this.nature, this.level, "def");
		this.spatk = CALC_STAT_ADV('tatsugiri', this.spatkev, this.spatkiv, this.nature, this.level, "spa");
		this.spdef = CALC_STAT_ADV('tatsugiri', this.spdefev, this.spdefiv, this.nature, this.level, "spd");
		this.spe = CALC_STAT_ADV('tatsugiri', this.speev, this.speiv, this.nature, this.level, "spe");
	}
}

function mon() {
	this.species = "";
	this.nature = "Serious";
	this.gigantamax = false;
	this.ability = "";
	this.teratype = "";
	this.item = "";
	this.move1 = "";
	this.move2 = "";
	this.move3 = "";
	this.move4 = "";
	this.gender = "";
	this.level = "";
	this.hp = 0;
	this.atk = 0;
	this.def = 0;
	this.spatk = 0;
	this.spdef = 0;
	this.spe = 0;
	this.hpev = 0;
	this.atkev = 0;
	this.defev = 0;
	this.spatkev = 0;
	this.spdefev = 0;
	this.speev = 0;
	this.hpiv = 31;
	this.atkiv = 31;
	this.defiv = 31;
	this.spatkiv = 31;
	this.spdefiv = 31;
	this.speiv = 31;
	this.calcStats = calcStats;
}

function addText(species) {
	if (species === "Thundurus" || species === "Tornadus" || species === "Landorus") {
		return species + "-Incarnate";
	}
	else if (species === "Zygarde") {
		return species + "-50%";
	}
	return species;
}

let NATURES = {
	'Adamant': ['atk', 'spa'],
	'Bashful': ['', ''],
	'Bold': ['def', 'atk'],
	'Brave': ['atk', 'spe'],
	'Calm': ['spd', 'atk'],
	'Careful': ['spd', 'spa'],
	'Docile': ['', ''],
	'Gentle': ['spd', 'def'],
	'Hardy': ['', ''],
	'Hasty': ['spe', 'def'],
	'Impish': ['def', 'spa'],
	'Jolly': ['spe', 'spa'],
	'Lax': ['def', 'spd'],
	'Lonely': ['atk', 'def'],
	'Mild': ['spa', 'def'],
	'Modest': ['spa', 'atk'],
	'Naive': ['spe', 'spd'],
	'Naughty': ['atk', 'spd'],
	'Quiet': ['spa', 'spe'],
	'Quirky': ['', ''],
	'Rash': ['spa', 'spd'],
	'Relaxed': ['def', 'spe'],
	'Sassy': ['spd', 'spe'],
	'Serious': ['', ''],
	'Timid': ['spe', 'atk']
};

function CALC_HP_ADV(species, evs, ivs, level) {
	let total = 1;
	console.log(species);
	let base = Pokedex[species]["baseStats"]["hp"];
	if (base === 1) {
		total = 1;
	} else {
		total = Math.floor((base * 2 + ivs + Math.floor(evs / 4)) * level / 100) + level + 10;
	}
	return total;
}

function SPECIAL_FORME_FILTERING(mon) {
	console.log(mon)
	if (mon.species.includes("-Gmax")) {
		mon.species = mon.species.replace("-Gmax", "");
		// mon.gigantamax = true;
	}
	else if (mon.species.includes("Pikachu") && mon.species === "Pikachu") {
		mon.species = "Pikachu";
		mon.gender = "M";
		mon.ability = "Static";
	}
	else if (mon.species === "Indeedee") {
		mon.species = "Indeedee-M";
	}
	else if (mon.species.includes("Kyurem") || mon.species.includes("Giratina") || mon.species.includes("Necrozma") || mon.species.includes("Wormadam") || mon.species.includes("Rotom") || mon.species.includes("Gourgeist") || mon.species.includes("Lycanroc") || mon.species.includes("Oricorio") || mon.species.includes("Zygarde")) {
		return mon;
	}
	else if (mon.species === "Scizor-Mega" || mon.species === "Blaziken-Mega") {
		mon.species = mon.species.replace("-Mega", "");
	}
	// else if (mon.species.includes("-") && mon.species !== "Porygon-Z" && mon.species !== "Kommo-o" && !mon.species.includes("Indeedee")) { // Check
	// 	console.log(mon.species);
	// 	if (Pokedex[mon.species.toLowerCase().replace(/[ '-]/g, '')]["ability"] === mon.ability) {
	// 		mon.ability = Pokedex[mon.species.split("-")[0]]["ab"];
	// 	}
	// 	mon.species = mon.species.split("-")[0];
	// }
	return mon;
}

function CALC_STAT_ADV(species, evs, ivs, nature, level, statName) {
	let base = Pokedex[species]["baseStats"][statName];
	var natureMods = NATURES[nature];
	var nature = natureMods[0] === statName ? 1.1 : natureMods[1] === statName ? 0.9 : 1;
	var total = Math.floor((Math.floor((base * 2 + ivs + Math.floor(evs / 4)) * level / 100) + 5) * nature);
	return total;
}